import { ref, readonly } from '@vue/composition-api';
import { defineStore } from 'pinia';

export const useEditorViewStore = defineStore('editor-view', () => {
  const isPreview = ref(false);
  const documentId = ref('');
  const recipientId = ref('');
  const authId = ref('');
  const authToken = ref({ jwt: '', exp: 0 });
  const tokenIsSynced = ref(true);
  const documentStatusSigned = ref(false);
  const documentRecalled = ref(false);
  const previewTokenExpired = ref(false);

  const setToken = (token: { jwt: string; exp: number }) => {
    authToken.value = token;
  };

  const emitNewToken = (token: { jwt: string; exp: number }) => {
    authToken.value = token;
    tokenIsSynced.value = false;
  };

  const setTokenIsSynced = (synced: boolean) => {
    tokenIsSynced.value = synced;
  };

  const setDocumentId = (id: string) => {
    documentId.value = id;
  };

  const setRecipientId = (id: string) => {
    recipientId.value = id;
  };

  const setAuthId = (id: string) => {
    authId.value = id;
  };

  const setIsPreview = (preview: boolean) => {
    isPreview.value = preview;
  };

  const emitSetDocumentStatusSigned = (signed: boolean) => {
    documentStatusSigned.value = signed;
  };

  const emitDocumentRecalled = (recalled: boolean) => {
    documentRecalled.value = recalled;
  };

  const emitPreviewTokenExpired = (expired: boolean) => {
    previewTokenExpired.value = expired;
  };

  return {
    isPreview: readonly(isPreview),
    documentId: readonly(documentId),
    recipientId: readonly(recipientId),
    authId: readonly(authId),
    authToken: readonly(authToken),
    tokenIsSynced: readonly(tokenIsSynced),
    documentStatusSigned: readonly(documentStatusSigned),
    documentRecalled: readonly(documentRecalled),
    previewTokenExpired: readonly(previewTokenExpired),

    setToken,
    emitNewToken,
    setTokenIsSynced,
    setDocumentId,
    setRecipientId,
    setAuthId,
    setIsPreview,
    emitSetDocumentStatusSigned,
    emitDocumentRecalled,
    emitPreviewTokenExpired,
  };
});
